/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DeprecatedProjectIndicator_project = {
    readonly name: string | null;
    readonly companyProjectId: number | null;
    readonly customProjectId: string | null;
    readonly projectColor: string | null;
    readonly " $refType": "DeprecatedProjectIndicator_project";
};
export type DeprecatedProjectIndicator_project$data = DeprecatedProjectIndicator_project;
export type DeprecatedProjectIndicator_project$key = {
    readonly " $data"?: DeprecatedProjectIndicator_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DeprecatedProjectIndicator_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeprecatedProjectIndicator_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = '86976a2c02c34c8e1e6236be7edd7f23';
export default node;
